import { render, staticRenderFns } from "./Item2.vue?vue&type=template&id=35c2f7b6&scoped=true"
import script from "./Item2.vue?vue&type=script&lang=js"
export * from "./Item2.vue?vue&type=script&lang=js"
import style0 from "./Item2.vue?vue&type=style&index=0&id=35c2f7b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c2f7b6",
  null
  
)

export default component.exports